import React from "react"

import Card from "./components/Card"
import {
  Section,
  Wrapper,
  Header,
  Eyebrow,
  Heading,
  Subhead,
  CallToAction,
  CardsWrapper,
  BackgroundTreatment,
} from "./styles/MulticolumnStepped.styled"

const MulticolumnStepped = ({ component }) => (
  <Section>
    <BackgroundTreatment>
      <img src={component?.backgroundImage?.url} />
    </BackgroundTreatment>
    <Wrapper>
      <Header>
        {component?.eyebrow && <Eyebrow>{component?.eyebrow}</Eyebrow>}
        {component?.heading && <Heading>{component?.heading}</Heading>}
        {component?.subhead && (
          <Subhead dangerouslySetInnerHTML={{ __html: component?.subhead }} />
        )}
        {component?.cta?.url && (
          <CallToAction className="arrow-link" href={component?.cta?.url}>
            {component?.cta?.label}
          </CallToAction>
        )}
      </Header>
      <CardsWrapper>
        {component?.cards.map((card, idx) => {
          return <Card key={card?.id} component={card} idx={idx} />
        })}
      </CardsWrapper>
    </Wrapper>
  </Section>
)

export default MulticolumnStepped
